/**
 * StreamRift View - Password-gated command center.
 *
 * SessionStorage gate: unlocked per tab — a same-tab refresh stays open, a new tab re-prompts.
 * Completely isolated from other views.
 */

import { useGate } from '@/hooks/ui/useGate';
import { StreamRiftGate, STREAMRIFT_GATE } from './StreamRiftGate';
import { EyeOfStreamRift } from './EyeOfStreamRift';
import { useFeedNeeds } from '@/hooks/useFeedNeeds';
import { LIVE_RESEARCH_SPORTS } from './liveSports';

export function StreamRiftView() {
  const { unlocked, unlock } = useGate(STREAMRIFT_GATE);
  // Consumer feed filters (feed-filters-per-view): the Eye reads moneyline
  // rows of exactly these sports; the feed tape shows whatever arrives.
  useFeedNeeds('streamrift', { sports: LIVE_RESEARCH_SPORTS });

  if (!unlocked) {
    return <StreamRiftGate onUnlock={unlock} />;
  }

  return <EyeOfStreamRift />;
}
